import React, { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { usePageTracking } from '../../../hooks';
import { AnalyticsPageCategory, AnalyticsPageType } from '../../../models';
import { MapSearchResult } from '../../../redux';
import { SearchResultViewer } from '../../organisms';

export function SearchResultPage(): ReactElement {
	const history = useHistory();
	usePageTracking(AnalyticsPageCategory.Result, AnalyticsPageType.Content);

	function navigateToMap(map: MapSearchResult): void {
		let queryString: string = '';

		if (map.topoLat && map.topoLng && map.topoName) {
			queryString = `?lat=${map.topoLat}&lng=${
				map.topoLng
			}&name=${map.topoName.capitalize()}`;
		}

		history.push(`/map/${map.id}${queryString}`);
	}

	function navigateToIndex(): void {
		history.push('/content');
	}

	return (
		<SearchResultViewer
			onMapClicked={navigateToMap}
			onNavigateToIndex={navigateToIndex}
		/>
	);
}
